import { Box, Button, Typography, useTheme } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import actions, { TYPES } from '~/actions'
import { getViewportSize } from '~/utils'
import { usePositionHandler } from './PositionHandler'

const message = {
  pt: {
    title: 'Termo de uso',
    msgErro: 'Não foi possivel fazer exibir o arquivo.',
    msgDownload: 'Baixe aqui ',
    msgType: 'o termo em pdf'
  },
  en: {
    title: 'Terms of use',
    msgErro: 'Unable to display the file.',
    msgDownload: 'Download here ',
    msgType: 'the term in pdf'
  },
  es: {
    title: 'condiciones de uso',
    msgErro: 'No se puede mostrar el archivo.',
    msgDownload: 'Descarga aquí ',
    msgType: 'el término en pdf'
  }
}

function Terms({ language }) {
  const dispatch = useDispatch()
  const { handlerShowPositionDialog, showPositionDialog } = usePositionHandler()
  const theme = useTheme()

  let lang = language.slice(0, 2) || 'pt'
  if (!['pt', 'en', 'es'].includes(lang)) lang = lang || 'pt'
  const { height, width } = getViewportSize()
  const { title, msgErro, msgType, msgDownload } = message[lang]
  const isMobile = width < theme.gofind.desktopMaxWidth
  const url = `https://s3.sa-east-1.amazonaws.com/gofind.img.repo/termos/${lang}.pdf`

  useEffect(() => {
    showPositionDialog && handlerShowPositionDialog(false)
  }, [showPositionDialog])

  useEffect(() => {
    console.log('cheguei aqui')
    document.title = title
    dispatch(
      actions.updateApp({
        view: TYPES.VIEW_TERM
      })
    )
  }, [])

  const downloadFile = () => window.open(url, '_parent')

  if (isMobile) {
    downloadFile()
  }

  return (
    <Box
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center'
      }}
    >
      <object
        data={url}
        type="application/pdf"
        width="100%"
        height={height}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <Box style={{ padding: 32 }}>
          <Typography align="center">
            {msgErro}
            <Button variant="text" onClick={downloadFile}>
              {msgDownload}
            </Button>
            {msgType}
          </Typography>
        </Box>
      </object>
    </Box>
  )
}

export default Terms
